<!-- C153176-4618 Responsive Design-->
<p-dialog class="snooze-dialog" [(visible)]="display" [modal]="true" [responsive]="true" [maximizable]="false" [appendTo]="'body'"
[styleClass]="'contextMenuModal schedule-Modal snooze-dialog'" [closable]="false" [dismissableMask]="true" [baseZIndex]="10000"
[closeOnEscape]="true" [style]="{'max-width':'440px','height':'200px','background': '#FFF', 'width': '100%'}" [resizable]="false">
<p-header>
    <div class="d-flex flex-row align-items-center justify-content-between align-items-center">
        <div class="snz-title">{{headerText}}</div>
        <button type="button" (click)="hideModal()" class="d-flex flex-row close qma-text">
            <img src="assets/qwyn/icons/close.svg" alt="Close">
        </button>
    </div>
</p-header>
<div class="snz-body d-flex flex-row flex-wrap align-items-center justify-content-start w-100">
    <form #snoozeForm="ngForm" class="w-100">
    <div  class="d-flex flex-row align-items-end justify-content-between mt-3 align-items-center mobile-snooze">
        <div class="snooze-label1 w-20 ps-2">{{labelText}}:</div>
        <div class="d-flex flex-row w-60 flex-nowrap justify-content-end">
            <div class="d-flex flex-row w-100 flex-nowrap align-items-start pe-2">
                <div class="ps-4 mobile-pl w-100 flex justify-content-end">
                    <p-dropdown [disabled]="checked" class="snooze-dropdown" [options]="availOptions" name="selectedOption" (onChange)="onSelection($event)" [styleClass]="'snooze-dropdown'"  placeholder="Select" [(ngModel)]="selectedOption"  name='selectedOption'  [autofocus]="false">

                    </p-dropdown>                    
                </div>
            </div>
        </div>
    </div>
    <div class="snz-body d-flex flex-row flex-wrap align-items-center justify-content-start ">    
        <div class="d-flex flex-row align-items-center justify-content-start mt-3  mobile-snooze">
            <div class="d-flex flex-row flex-nowrap justify-content-between ps-2">
                <p-checkbox name="checked" [styleClass]="'advance-checkbox'"  [(ngModel)]="checked" binary="true" inputId="binary" ></p-checkbox>      
                <div class="snooze-label1 ps-1">Custom Range</div>
            </div>
        </div>
    </div>
    <div *ngIf="checked" class="d-flex pt-4 flex-row justify-content-between align-items-center pe-2 mobile-snooze">
        <div class="snooze-label1 ps-2">DD:</div>
        <div class="d-flex flex-row w-100 flex-nowrap justify-content-between">
            <div class="d-flex flex-row w-100 flex-nowrap align-items-start ">
                <div class="ps-2 mobile-pl w-100">
                    <p-dropdown  class="snooze-dropdown" [options]="dayOptions" name="selectedDayOption" (onChange)="onSelection($event)" [styleClass]="'snooze-dropdown'"  placeholder="00" [(ngModel)]="selectedDayOption">
                    </p-dropdown>                    
                </div>
            </div>
        </div>
        <div class="snooze-label1 ps-3">HH:</div>
        <div class="d-flex w-100 flex-row flex-nowrap justify-content-between">
            <div class="d-flex flex-row w-100 flex-nowrap align-items-start ">
                <div class="ps-2 mobile-pl w-100">
                    <p-dropdown class="snooze-dropdown" [options]="hhOptions" name="selectedHhOption" (onChange)="onSelection($event)" [styleClass]="'snooze-dropdown'"  placeholder="00" [(ngModel)]="selectedHhOption">
                    </p-dropdown>                    
                </div>
            </div>
        </div>
        <div class="snooze-label1 ps-3">MM:</div>
        <div class="d-flex flex-row flex-nowrap w-100 justify-content-between">
            <div class="d-flex flex-row flex-nowrap w-100 align-items-start ">
                <div class="ps-2 mobile-pl w-100">
                    <p-dropdown class="snooze-dropdown" [options]="mmOptions" name="selectedMmOption" (onChange)="onSelection($event)" [styleClass]="'snooze-dropdown'"  placeholder="00" [(ngModel)]="selectedMmOption">
                    </p-dropdown>                    
                </div>
            </div>
        </div>
    </div>
</form>
</div>
<p-footer>
   
    <div class="d-flex flex-row flex-wrap justify-content-center px-3 btn-wrappersn ">
        <button type="reset" class=" clear-btnsn " (click)="resetForm(snoozeForm)">Reset</button>
        <button type="submit" class=" search-btnsn" [disabled]="isDisabled" (click)="setSnooze($event)">Save</button>
    </div>
</p-footer>
</p-dialog>
